export const tableTitle = ['Номер пацієнта', 'Прізвище', "Ім'я",'По батькові', 'Стать', 'Номер картки','Номер телефону', '']
export const filterDate = [
    {name: 'patientNumber', placeholder: 'Пошук за номером пацієнта'},
    {name: 'lastName', placeholder: "Пошук за прізвищем"},
    {name: 'name', placeholder: "Пошук за ім'ям"},
    {name: 'middleName', placeholder: 'Пошук за ім’ям по батькові'},
    {name: 'gender', type: 'select', options: ['', 'male', 'female'], placeholder: 'Всі'},
    {name: 'cardNumber', placeholder: 'Пошук за номером картки'},
    {name: 'phoneNumber', placeholder: 'Пошук за номером телефону'},
]
export const searchOptions = [
    { value: "patientNumber",name: "за номером пацієнта", type: "text" },
    { value: "lastName", name: "за прізвищем", type: "text" },
    { value: "name", name: "за ім'ям", type: "text" },
    { value: "middleName", name: "за по батькові", type: "text" },
    { value: "cardNumber", name: "за номером картки", type: "text" },
    { value: "phoneNumber", name: "за номером телефону", type: "text" },
]